import { AccountTreeOutlined, AdsClickOutlined, PersonAddOutlined } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router';

const DashboardHeader = () => {
    const navigate = useNavigate();
    return (
        <>
            <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', // Vibrant Enterprise Blue
                        px: { xs: 2, md: 4 },
                        pt: 4,
                        pb: 7,
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '10px'
                    }}
                >
                    {/* Decorative circles */}
                    {[
                        { size: 200, top: -80, right: -60, op: 0.07 },
                        { size: 120, top: 10, right: 120, op: 0.05 }
                    ].map((c, i) => (
                        <Box
                            key={i}
                            sx={{
                                position: 'absolute',
                                top: c.top,
                                right: c.right,
                                width: c.size,
                                height: c.size,
                                borderRadius: '50%',
                                bgcolor: '#fff',
                                opacity: c.op
                            }}
                        />
                    ))}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                        <Box>
                            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.7)', letterSpacing: '0.12em' }}>
                                HR Dashboard
                            </Typography>
                            <Typography variant="h3" fontWeight={800} sx={{ color: '#fff', mt: 0.5 }}>
                                Employee Overview
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', mt: 0.5 }}>
                                Real-time view of your sales team status and performance
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1.5, mt: { xs: 0, sm: 2 } }}>
                            <Button
                                variant="contained"
                                startIcon={<AccountTreeOutlined />}
                                onClick={() => navigate('/HR/hierarchy')}
                                sx={{
                                    bgcolor: 'rgba(255, 255, 255, 0.15)',
                                    color: '#fff',
                                    backdropFilter: 'blur(8px)',
                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1.2,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.25)',
                                        borderColor: '#fff'
                                    }
                                }}
                            >
                                Hierarchy
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<PersonAddOutlined />}
                                component="a"
                                onClick={() => navigate('/HR/add-sales-employee')}
                                sx={{
                                    bgcolor: '#fff',
                                    color: '#1e40af',
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1.2,
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: '0.95rem',
                                    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.15)',
                                    '&:hover': {
                                        bgcolor: 'rgba(255,255,255,0.9)',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 6px 20px rgba(0,0,0,0.2)'
                                    }
                                }}
                            >
                                Add Employee
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<AdsClickOutlined />}
                                onClick={() => navigate('/HR/target-settings')}
                                sx={{
                                    bgcolor: 'rgba(255, 255, 255, 0.15)',
                                    color: '#fff',
                                    backdropFilter: 'blur(8px)',
                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1.2,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '0.95rem',
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.25)',
                                        borderColor: '#fff'
                                    }
                                }}
                            >
                                Target Settings
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </motion.div>
        </>
    );
};

export default DashboardHeader;
